import React from "react";
import logo from "../../assets/images/chart-options-icon.svg";

const chartOptionsLogo = props => <img src={logo} alt="chart-options" />;

export default chartOptionsLogo;
